var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFranchiseeIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 175,
    height: 175,
    viewBox: "0 0 175 175",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4371_12415)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 175,
    rx: 87.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.4248,
    y: 21.7705,
    width: 29.661,
    height: 47.4784,
    transform: "rotate(1.82764 45.4248 21.7705)",
    fill: "#DFE2E7"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_4371_12415",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 25.6787,
    width: 33.9247,
    height: 46.5788,
    rx: 1,
    transform: "rotate(-6.26942 35 25.6787)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 25.6787,
    width: 33.9247,
    height: 46.5788,
    rx: 1,
    transform: "rotate(-6.26942 35 25.6787)",
    fill: "white",
    stroke: "#00004B",
    strokeWidth: 2.6,
    mask: "url(#path-4-inside-1_4371_12415)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.9422,
    y: 26.8331,
    width: 27.3728,
    height: 15.4734,
    rx: 7.73671,
    transform: "rotate(1.82764 48.9422 26.8331)",
    stroke: "#00004B",
    strokeWidth: 1.356
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-2_4371_12415",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.751,
    y: 20.6406,
    width: 33.767,
    height: 44.5536,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 38.751,
    y: 20.6406,
    width: 33.767,
    height: 44.5536,
    rx: 1,
    fill: "white",
    stroke: "#00004B",
    strokeWidth: 2.6,
    mask: "url(#path-6-inside-2_4371_12415)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 41.0967,
    y: 25.7979,
    width: 27.2012,
    height: 1.40696,
    fill: "#00004B"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 43,
    y: 47,
    width: 21,
    height: 1,
    fill: "#00004B"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 43,
    y: 45,
    width: 21,
    height: 1,
    fill: "#00004B"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 43,
    y: 48,
    width: 21,
    height: 1,
    fill: "#00004B"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 41,
    y: 28,
    width: 23,
    height: 4,
    fill: "#73DC78"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 41,
    y: 33,
    width: 23,
    height: 4,
    fill: "#00004B"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 41,
    y: 38,
    width: 23,
    height: 4,
    fill: "#73DC78"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 41.0967,
    y: 52.9316,
    width: 27.6702,
    height: 1.40696,
    fill: "#00004B"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 41.0967,
    y: 55.2432,
    width: 27.6702,
    height: 1.40696,
    fill: "#00004B"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 41.8718,
    y: 43.8718,
    width: 26.2565,
    height: 6.25647,
    stroke: "#00004B",
    strokeWidth: 1.74353
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2275 22.9844C54.5404 21.8946 55.2315 19.5367 55.1662 19.2692C55.0846 18.9348 54.486 17.9258 54.4724 17.3373C54.462 16.8876 57.9415 16.8876 57.9415 17.3373C57.9415 17.8256 57.1451 18.9981 57.1253 19.2692C57.0926 19.715 57.683 21.9689 57.9415 22.9844",
    stroke: "#00004B",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.166 22.048C55.3225 21.2809 55.6053 19.6061 55.6643 19.4327C55.7658 19.1343 55.2833 18.4756 55.2833 18.2372C55.2833 17.7086 56.8638 17.7328 57.023 18.0728C57.1454 18.3343 56.6353 19.0404 56.6149 19.4327C56.5986 19.7466 56.8938 21.3332 57.023 22.048",
    stroke: "#00004B",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8213 19.5762L53.045 23.4537H54.3126V23.0436L54.9837 23.4537H57.0716L57.7427 23.0436V23.4537H59.1222L59.3832 19.5762H52.8213Z",
    fill: "#73DC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0459 23.0068V23.4542H54.4627V23.0068H53.0459Z",
    fill: "#009933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7422 23.0068V23.4542H59.159V23.0068H57.7422Z",
    fill: "#009933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2825 23.0068L55.0215 23.4542H57.0348L56.7365 23.0068H55.2825Z",
    fill: "#009933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.414 50.4366C106.014 57.6393 109.015 58.8395 110.816 60.6402C112.256 62.0807 110.215 65.2419 109.015 66.6424C108.415 66.6424 107.454 67.3627 108.414 70.2438C109.615 73.8451 119.218 76.8463 121.019 76.246C122.459 75.7659 124.42 68.4433 125.221 64.2418C124.02 64.2418 122.285 60.8007 122.732 60.3534C128.225 54.8604 126.577 50.466 127.126 50.466C130.509 50.466 131.521 41.6773 127.676 43.3252C126.904 39.8905 125.256 34.8666 124.02 33.6303C121.02 30.6292 117.418 29.4287 111.415 32.4295C105.81 35.2316 104.814 43.234 105.414 50.4366Z",
    fill: "white",
    stroke: "#00004B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.354 52.1654C123.312 52.1242 126.029 48.8179 126.028 49.3671C126.433 50.0419 128.325 53.9021 125.048 58.4186C121.771 62.9352 115.592 63.6491 112.296 62.5505C108.374 61.2432 107.46 58.3704 106.803 57.0576C106.254 55.959 105.592 52.3058 105.705 51.5646C106.819 51.9189 108.102 53.0654 109.357 53.9017C111.095 55.0592 112.45 55.8736 115.145 54.4805C116.788 53.6315 118.136 52.1963 120.354 52.1654Z",
    fill: "#00004B",
    stroke: "#00004B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.352 50.4655C109.332 50.045 110.585 50.4256 112.204 51.3512C111.766 52.1227 109.719 53.4492 108.437 53.6053C107.154 53.7614 105.259 53.214 104.094 52.6376C103.507 52.663 106.017 50.7492 107.352 50.4655Z",
    fill: "#00004B",
    stroke: "#00004B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.239 53.762C114.492 53.2122 113.714 52.0059 112.727 51.3532C113.369 50.7404 115.423 50.1028 117.239 50.466C119.986 51.0153 120.535 51.5644 122.183 52.663C121.084 53.2123 119.985 54.3117 117.239 53.762Z",
    fill: "#00004B",
    stroke: "#00004B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.846 69.6602C150.273 69.6607 149.76 73.1369 150.455 75.2236H153.236C153.932 73.1369 153.932 69.6595 151.846 69.6602Z",
    fill: "white",
    stroke: "#00004B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5215 79.5788C97.1904 70.2407 104.093 66.3957 108.451 66.3957C109.378 68.2499 113.217 72.6446 115.618 72.6446C119.219 72.6446 125.221 65.681 125.221 64.2414C126.38 64.0096 129.091 64.0827 131.824 64.8419C142.628 67.843 148.11 76.1396 152.395 83.4238C152.395 84.119 150.24 83.2429 144.155 86.7196C139.288 89.501 137.014 94.4587 137.014 94.4587C140.963 97.9404 146.553 102.234 146.979 107.904C147.243 111.413 142.807 131.546 140.026 141.281L98.3048 139.195C97.1459 138.036 96.0797 132.52 95.5235 114.162C95.3096 107.105 96.2149 101.038 97.5718 96.0005H87.8525C87.8525 92.4979 90.0498 84.5224 92.5215 79.5788Z",
    fill: "#DFE2E7",
    stroke: "#00004B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.022 85.249C130.022 79.0067 132.023 70.2435 133.023 65.4417C133.023 65.4417 131.222 64.2413 130.022 64.2412H127.621C127.221 66.8422 126.597 71.5853 126.421 72.6444C125.82 76.2457 125.62 82.448 125.22 87.6499C123.419 88.2501 106.125 87.4851 106.253 86.7189C106.802 83.4231 108.45 71.3386 109 66.3949L104.605 67.4935C104.605 68.8941 104.813 71.3386 103.612 76.2457C101.672 84.1757 100.211 89.4654 98.0138 94.409C94.2294 102.924 93.4083 114.06 93.4083 120.662C93.4083 124.264 96.521 141.493 95.2084 145.872C93.4092 151.874 91.9715 175.155 93.4086 175.705C100.211 177.902 104.056 178.451 111.197 178.451L115.617 169.28L119.986 177.902C127.676 177.353 138.112 173.508 139.625 172.409C141.138 171.31 142.176 156.075 139.625 145.872C138.665 142.03 144.155 131.212 145.628 120.662L136.624 96.6533C134.223 96.2532 130.022 91.4913 130.022 85.249Z",
    fill: "#00004B",
    stroke: "#00004B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5631 96.7234L70.2428 80.2759C70.0939 80.0131 70.1056 79.689 70.2732 79.4377L71.68 77.3275C72.0106 76.8316 72.7478 76.8583 73.0416 77.3768L82.3619 93.8244C82.5108 94.0871 82.499 94.4113 82.3315 94.6625L80.9247 96.7728C80.5941 97.2686 79.8569 97.2419 79.5631 96.7234Z",
    fill: "#00004B",
    stroke: "#00004B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6198 114.734C93.6198 108.691 95.9021 98.5423 96.8521 96.0004H87.8521C85.8521 102 87.8606 108.226 86.4833 106.512C85.1059 104.798 79.5303 97.3914 78.835 96.0004C78.2787 94.8877 79.7408 93.6036 80.4362 92.2129C81.1315 90.8222 80.4372 90.0156 78.835 87.0428C76.459 82.6346 74.2828 82.2907 72.1968 85.0721C70.1103 87.854 73.2712 94.6924 73.2712 96.7785C73.2712 98.8645 75.358 109.293 82.3115 117.637C89.265 125.981 93.6198 119.553 93.6198 114.734Z",
    fill: "white",
    stroke: "#00004B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.016 109.295C155.502 102.616 152.773 89.8255 151.15 84.2627C149.76 84.2627 148.136 84.2637 143.502 87.0449C140.025 89.1313 137.014 93.8603 137.014 93.8603C137.709 101.509 139.188 120.282 146.976 125.288C156.711 131.546 156.711 118.335 156.016 109.295Z",
    fill: "white",
    stroke: "#00004B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.893 103.037C142.111 114.857 143.85 120.42 146.978 124.592C150.455 129.23 156.124 127.16 158.799 121.811C161.581 116.248 160.885 105.122 158.799 98.8642C158.307 97.3891 156.018 90.5203 156.018 89.1296C156.018 87.7389 158.104 80.0896 156.713 77.3082C155.323 74.5268 149.42 73.8311 148.029 77.3078C146.638 80.7846 147.144 84.7735 149.229 88.2502C150.302 90.039 146.404 96.6151 144.893 103.037Z",
    fill: "white",
    stroke: "#00004B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.63 86.4498C151.031 87.6503 152.231 85.8496 152.231 85.8496",
    stroke: "#00004B",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.229 88.2505C149.83 88.8507 152.831 91.8518 156.432 85.8496",
    stroke: "#00004B",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.43 82.8483C149.23 84.0487 151.631 82.8483 152.231 82.248",
    stroke: "#00004B",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.029 79.2467C149.83 80.4472 152.231 78.6465 152.231 78.6465",
    stroke: "#00004B",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.133 40.4298C135.809 44.3301 118.147 41.405 115.358 41.405C113.271 41.405 104.784 41.1206 100.019 40.9508C98.9349 40.7772 96.5799 40.7225 95.8362 39.9423C94.2901 38.3205 96.1784 36.4693 98.1084 35.6596C101.966 34.0412 105.917 34.1178 109.326 33.4678C108.551 34.9304 105.876 39.8447 110.71 37.5045C116.752 34.5793 125.583 29.7039 132.091 30.1914C138.598 30.679 140.457 36.5295 138.133 40.4298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0898 40.9175C99.3798 40.928 99.6907 40.9391 100.019 40.9508M100.019 40.9508C104.784 41.1206 113.271 41.405 115.358 41.405C118.147 41.405 135.809 44.3301 138.133 40.4298C140.457 36.5295 138.598 30.679 132.091 30.1914C125.583 29.7039 116.752 34.5793 110.71 37.5045C105.876 39.8447 108.551 34.9304 109.326 33.4678C105.917 34.1178 101.966 34.0412 98.1084 35.6596C96.1784 36.4693 94.2901 38.3205 95.8362 39.9423C96.5799 40.7225 98.9349 40.7772 100.019 40.9508Z",
    stroke: "#00004B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.778 27.2663C108.537 31.1704 107.764 34.2544 106.989 37.0171L106.989 37.9922L110.708 37.0171L128.37 30.1916C128.37 29.704 128.277 28.3389 127.905 26.7788C127.441 24.8286 125.581 23.8535 124.187 23.366C122.792 22.8785 117.215 22.8785 114.891 23.366C112.567 23.8535 110.243 25.8037 109.778 27.2663Z",
    fill: "white",
    stroke: "#00004B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.778 36.0428C108.291 36.8229 103.736 39.455 99.0879 40.9183L98.623 40.9183C99.8625 41.0809 102.62 41.4059 103.736 41.4059C105.13 41.4059 116.69 36.7338 130.694 42.8675C137.121 45.6823 142.508 40.0292 139.99 34.0931C137.766 28.8481 126.926 28.4991 122.328 29.7049C118.61 30.68 111.638 35.0678 109.778 36.0428Z",
    fill: "white",
    stroke: "#00004B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8871 89.4658L78.2393 91.1137",
    stroke: "#00004B",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2397 86.7197L76.5918 88.3676",
    stroke: "#00004B",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0424 84.5225L74.3945 86.1703",
    stroke: "#00004B",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.028 47.1703C125.251 47.1703 127.127 43.8745 123.831 42.776C121.634 43.3252 120.535 43.8745 117.789 42.7759C116.648 42.3197 113.944 42.2266 112.296 42.776C110.838 43.2618 110.099 42.2266 108.451 42.2266C107.352 42.2266 105.704 43.3253 105.704 42.776C105.704 42.2266 104.197 41.4477 106.803 40.5792C110.098 39.4808 118.338 38.3818 121.634 40.0296C122.027 40.2261 126.578 41.128 127.676 42.776C127.493 43.8746 127.405 44.9666 127.127 45.5225C126.577 46.621 126.577 47.1703 126.028 47.1703Z",
    fill: "#00004B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M104.606 110.889C103.727 108.692 103.691 101.001 104.057 98.2549L126.578 99.3535C127.127 101.001 126.029 109.79 124.93 111.987C124.381 113.086 105.046 111.987 104.606 110.889Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeDasharray: "1.5 1.5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 174,
    height: 174,
    rx: 87,
    stroke: "#C6E6FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4371_12415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 175,
    rx: 87.5,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFranchiseeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Franchisee_icon.1fbb7dd3b3595882d3fe48f4e609d7ec.svg";